import {ActivityHeader} from '@github-ui/commenting/ActivityHeader'
import {ReactionViewerBase} from '@github-ui/reaction-viewer/ReactionViewerBase'
import {VerifiedHTMLDiv} from '@github-ui/safe-html/VerifiedHTML'
import type {IssueComment} from '../../page-data/payloads/issue-comments'
import type {ReactionContent} from '@github-ui/reaction-viewer/ReactionGroupsUtils'

interface IssueCommentItemProps {
  comment: IssueComment
  pullRequestAuthorLogin: string
  canReact: boolean
  onReact: (reaction: ReactionContent, viewerHasReacted: boolean) => void
}

export function IssueCommentItem({
  comment,
  pullRequestAuthorLogin,
  canReact,
  onReact,
}: IssueCommentItemProps): React.ReactElement | null {
  if (!comment.repository) return null

  return (
    <div className="border rounded-2">
      <ActivityHeader
        avatarUrl={comment.authorAvatarUrl || ''}
        comment={{
          id: comment.id,
          authorAssociation: comment.authorAssociation,
          createdAt: comment.createdAt,
          isHidden: comment.isHidden,
          minimizedReason: comment.minimizedReason,
          repository: comment.repository,
          url: comment.url,
        }}
        commentAuthorLogin={comment.authorLogin}
        commentSubjectType="pull request"
        commentSubjectAuthorLogin={pullRequestAuthorLogin}
        forceInlineAvatar
        isMinimized={false}
      />
      <div className="pr-p-3">
        <VerifiedHTMLDiv className="markdown-body mt-1 f5" html={comment.bodyHtml} />
        {comment.reactionGroups.length > 0 && (
          <div className="mt-2">
            <ReactionViewerBase
              reactionGroups={comment.reactionGroups}
              canReact={canReact && comment.viewerCanReact}
              onReact={onReact}
            />
          </div>
        )}
      </div>
    </div>
  )
}
